<template>
  <form
    role="search"
    :id="idString"
    method="get"
    :action="searchPage"
    :class="showFilters ? 'showfilters' : ''"
  >
    <div class="searchinput">
      <SearchInput
        :baseApiUrl="baseApiUrl"
        :texts="texts"
        :suggestSokOptions="suggestSokOptions"
        :idString="idString"
        :showAnswer="showAnswer"
      ></SearchInput>
    </div>
    <SearchFilters
      v-if="showFilters"
      :selectedFilter="selectedFilter"
      :sokFilter="sokFilter"
      :texts="texts"
      @filterSelected="filterSelected"
    ></SearchFilters>
    <SearchFacets
      v-if="showFlerFilters"
      :selectedFacets="selectedFacets"
      :sokFacets="sokFacets"
      :texts="texts"
      @facetSelected="facetSelected"
    ></SearchFacets>
  </form>
</template>

<script>
import SearchInput from "./searchinput.vue";
import SearchFilters from "./searchfilters.vue";
import SearchFacets from "./searchfacets.vue";

export default {
  name: "SearchForm",
  props: {
    baseApiUrl: String,
    searchPage: String,
    texts: Object,
    suggestSokOptions: Object,
    idString: String,
    selectedFilter: String,
    selectedFacets: Object,
    sokFilter: Object,
    sokFacets: Object,
    showFilters: {
      type: Boolean,
      default: false,
    },
    showFlerFilters: {
      type: Boolean,
      default: false,
    },
    showAnswer: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {};
  },
  created() {},
  components: {
    SearchInput,
    SearchFilters,
    SearchFacets
  },
  methods: {
    filterSelected(selected) {
      this.$emit("filterSelected", selected);
    },
    facetSelected(selected, facetnamn) { 
      this.$emit("facetSelected", selected, facetnamn);
    },
  },
};
</script>
